export default __webpack_public_path__ + "static/media/primary-logo.ee51d726.svg";